import { IViewBookingDetails } from '../interfaces/viewBookingRes';

export function generatePretravelLink(booking: IViewBookingDetails) {
  const applicationUrl =
    process.env.REACT_APP_APPLICATION_URL ?? 'https://res.hotairhotair.com';

  let surveyLink = booking.surveyStatus;
  if (booking.surveyCount > 1) {
    surveyLink = `<a className=${'underline'} style="color:blue; text-decoration-line: underline;"  onclick='view(${booking.bookingId}, 2)' title='This booking has multiple surveys sent. View booking to select.'>${booking.surveyStatus}</a>*`;
  } else {
    if (
      Number(booking.surveyStatusId) > 1 ||
      Number(booking.surveyStatusId) === -1
    ) {
      surveyLink = `<a className=${'underline'} style="color:blue; text-decoration-line: underline;" href="${applicationUrl}/survey/survey.asp?id=${booking.bookingId}&c=${booking.urlCode}&comp=1&edit=1" target=_blank>${booking.surveyStatus}</a>`;
    } else if (Number(booking.surveyStatusId) === 1) {
      surveyLink = `<a className=${'underline'} style="color:blue; text-decoration-line: underline;" href="${applicationUrl}/survey/survey.asp?id=${booking.bookingId}&c=${booking.urlCode}" target=_blank>${booking.surveyStatus}</a>`;
    } else if (booking.calcPax) {
      if (booking.urlCode.length > 0) {
        surveyLink = `<a className=${'underline'} style="color:blue; text-decoration-line: underline;" href="${applicationUrl}/survey/survey.asp?id=${booking.bookingId}&c=${booking.urlCode}" target=_blank>${booking.surveyStatus}</a>`;
      } else {
        const encodedDate = encodeURIComponent(booking.actualDate);
        surveyLink = `<a className=${'underline'} style="color:blue; text-decoration-line: underline;" href="${applicationUrl}/survey/survey.asp?guid=${booking.bookingGuid}&date=${encodedDate}&pid=${booking.bookingProductId}&t=2" target=_blank>${booking.surveyStatus}</a>`;
      }
    }
  }
  return surveyLink;
}
